import { useState } from 'react';
import classNames from 'classnames';
import css from './toggle.module.scss';

interface ToggleProps {
  onToggleLeft: () => void;
  onToggleRight: () => void;
  labelLeft: string;
  labelRight: string;
}

export default function Toggle({ onToggleLeft, onToggleRight, labelLeft, labelRight }: Readonly<ToggleProps>) {
  const [value, setValue] = useState(true);

  function handleToggle(v: boolean) {
    if (value === v) return;

    setValue(v);
    v ? onToggleLeft() : onToggleRight();
  }

  return (
    <div className={css.toggle}>
      <button onClick={() => handleToggle(true)} className={classNames(css.left, value ? css.active : '')}>
        <p>{labelLeft}</p>
      </button>
      <button onClick={() => handleToggle(false)} className={classNames(css.right, !value ? css.active : '')}>
        <p>{labelRight}</p>
      </button>
    </div>
  );
}
